import React from 'react';
import DateSelector from 'components/common/dateselector';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
const MainMenu = (props) => {
    return (
        <div className="main-menu display--flex">

            <div className="main-menu__quicknav display--flex__flex--start--center">
                <Link className={`font--bold main-menu__quicknav__item ${props.overviewIsActive ? 'active' : ''}`} to={'/'}>
                    <span> Overview</span>
                </Link>
                <Link className={`font--bold main-menu__quicknav__item ${props.comparisonIsActive ? 'active' : ''}`} to={'/comparison/'}>
                    <span> Comparison</span>
                </Link>
            </div>
            {!props.onlyLeftMenu &&
                <DateSelector className="display--flex__flex--end--center" />
            }
        </div>
    );
}

MainMenu.propTypes = {
    overviewIsActive: PropTypes.bool.isRequired,
    onlyLeftMenu: PropTypes.bool.isRequired,
    comparisonIsActive: PropTypes.bool.isRequired
}
export default MainMenu;


// WEBPACK FOOTER //
// ./src/components/common/mainmenu.jsx